import React, { useState, useRef, useEffect } from "react";

interface SearchProps {
  search: string;
  onSearchChange: (value: string) => void;
  onClick: () => void;
  placeholder?: string;
}

const Search: React.FC<SearchProps> = ({
  search,
  onSearchChange,
  onClick,
  placeholder = "Search",
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const toggleInput = () => {
    setIsVisible((prev) => !prev);
  };

  const handleSearchButtonClick = () => {
    if (!isVisible) {
      setIsVisible(true);
      return;
    }

    onClick();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onClick();
    }
  };

  // ✅ Close on click outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={`flex items-center hover:border-greenBg focus-within:border-greenBg  transition-all duration-300 ${
        isVisible ? "w-80 pr-3 gap-2" : "w-[32px] justify-center"
      } bg-[#F6F6F7] border border-gray-500/30 h-[32px] rounded-[5px] overflow-hidden`}
    >
      {isVisible && (
        <input
          type="text"
          value={search}
          className="w-full h-full pl-4 outline-none placeholder-gray-500 text-sm"
          placeholder={placeholder}
          onChange={(e) => onSearchChange(e.target.value)}
          onKeyDown={handleKeyDown}
          autoFocus
        />
      )}

      <button
        type="button"
        onClick={handleSearchButtonClick}
        className="flex items-center justify-center bg-[#F6F6F7]"
        aria-label={isVisible ? "Submit Search" : "Toggle Search"}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 30 30"
          fill="#6B7280"
        >
          <path d="M 13 3 C 7.489 3 3 7.489 3 13s4.489 10 10 10c2.397 0 4.598-0.851 6.323-2.264l5.97 5.97a1 1 0 1 0 1.415-1.415l-5.97-5.97A9.937 9.937 0 0 0 23 13c0-5.511-4.489-10-10-10zm0 2c4.431 0 8 3.569 8 8s-3.569 8-8 8-8-3.569-8-8 3.569-8 8-8z" />
        </svg>
      </button>
    </div>
  );
};

export default Search;
